<template>
  <v-dialog v-model="showDialogForm" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ dialogTitle }}
        </span>
      </v-card-title>

      <v-card-text>
        <SeminarEmailForm
          ref="seminarEmailDialogForm"
          :values="item"
          :errors="violations"
          :initial-values="item"
          :ref-form="item.sentAt ? 'viewForm' : (item['@id'] ? 'editForm' : 'createForm')"
        />
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="showDialogForm = false">{{ $t('Close') }}</v-btn>
        <v-spacer />
        <v-btn color="primary" :loading="isLoading" @click="sendForm" :disabled="!!this.item.sentAt">{{ $t('Save') }}</v-btn>
      </v-card-actions>
    </v-card>

    <Loading :visible="isLoading" />
  </v-dialog>
</template>

<script>
import SeminarEmailForm from './Form';
import Loading from '@/components/Loading';
import NotificationMixin from '@/mixins/NotificationMixin';
import DialogMixin from '@/mixins/DialogMixin';

export default {
  name: 'SeminarEmailDialog',
  mixins: [NotificationMixin, DialogMixin],
  components: { Loading, SeminarEmailForm },
  props: {
    value: { type: Boolean, required: true },
    handleCreated: { type: Function, required: false },
    handleUpdated: { type: Function, required: false },
    emailItem: { type: Object, required: false, default: () => ({}) },
    createEmail: { type: Function, required: false },
    updateEmail: { type: Function, required: false }
  },
  data() {
    return {
      item: {},
      isLoading: false,
      violations: {},

      createMessage: this.$t('successfullyCreated'),
      updateMessage: this.$t('successfullyUpdated')
    };
  },
  computed: {
    showDialogForm: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
        if (!v) this.$emit('close');
      }
    },
    dialogTitle() {
      return this.item?.['@id'] ? this.$t('Edit Email') || 'Edit Email' : this.$t('New Email') || 'New Email';
    }
  },
  methods: {
    async sendForm() {
      const formRef = this.$refs.seminarEmailDialogForm;
      if (!formRef) return;

      formRef.$v.$touch();
      if (formRef.$v.$invalid) return;

      const payload = {
        subject: formRef.item.subject,
        body: formRef.item.body,
        sendToNewParticipants: formRef.item.sendToNewParticipants || false,
      };

      const isUpdate = !!this.item['@id'];

      const op = isUpdate ? this.updateEmail : this.createEmail;

      try {
        this.isLoading = true;
        this.violations = {};

        if (op) {
          const result = await op({ item: this.item, payload });
          this.afterSuccess(isUpdate, result);
          return;
        }

        if (isUpdate && this.handleUpdated) {
          const result = await this.handleUpdated({ item: this.item, payload });
          this.afterSuccess(true, result);
          return;
        }
        if (!isUpdate && this.handleCreated) {
          const result = await this.handleCreated({ item: this.item, payload });
          this.afterSuccess(false, result);
          return;
        }

        this.showError(this.$t('No handler provided') || 'No handler provided');
      } catch (e) {
        const violations =
          e?.graphQLErrors?.[0]?.extensions?.validation || e?.response?.data?.violations || e?.violations || {};
        this.violations = violations;

        const msg = e?.graphQLErrors?.[0]?.message || e?.message || this.$t('Submit failed');
        this.showError(msg);
      } finally {
        this.isLoading = false;
      }
    },

    afterSuccess(isUpdate, result) {
      this.showMessage(isUpdate ? this.updateMessage : this.createMessage);
      this.showDialogForm = false;
      this.$emit(isUpdate ? 'updated' : 'created', result);
    },

    resetForm() {
      this.item = { ...(this.emailItem || {}) };
      const formRef = this.$refs.seminarEmailDialogForm;
      formRef && formRef.$v && formRef.$v.$reset();
      this.violations = {};
    },
  },
  watch: {
    emailItem: {
      immediate: true,
      handler() {
        this.item = { ...(this.emailItem || {}) };
        this.$nextTick(() => this.resetForm());
      }
    },
  }
};
</script>
